<template>
  <list-page icone="mdi-receipt-text" titulo="NFS-e" @novo="Novo()" @atualizar="Atualizar()">
    
    <template v-slot:botoes>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon color="click" class="mb-2" v-on="on" @click="GerarNFSe()" style="margin-top: 10px">
            <v-icon>mdi-plus-box-multiple-outline</v-icon>
          </v-btn>
        </template>
        <span>Gerar de Receitas</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon color="click" class="mb-2" v-on="on" @click="EnviarLote()" style="margin-top: 10px">
            <v-icon>mdi-send-outline</v-icon>
          </v-btn>
        </template>
        <span>Enviar Lote</span>
      </v-tooltip>
      
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon color="click" class="mb-2" v-on="on" @click="AtualizarLote()" style="margin-top: 10px">
            <v-icon>mdi-cloud-refresh-variant-outline</v-icon>
          </v-btn>
        </template>
        <span>Atualizar Lote</span>
      </v-tooltip> -->

    </template>

    <template v-slot:corpo>

      <v-expansion-panels focusable>
        <v-expansion-panel>
          <v-expansion-panel-header>Filtros</v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5">
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número RPS" v-model="filtro.numeroRpsInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número RPS" v-model="filtro.numeroRpsFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número" v-model="filtro.numeroInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número" v-model="filtro.numeroFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field type="date" label="Emissão" v-model="filtro.dataEmissaoInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field type="date" label="Emissão" v-model="filtro.dataEmissaoFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>              
              <v-col cols="12" sm="12" md="4">              
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field type="number" label="Valor" v-model.number="filtro.valorInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field type="number" label="Valor" v-model.number="filtro.valorFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número Recebível" v-model="filtro.recebivelInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Número Recebível" v-model="filtro.recebivelFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="4">
                <v-row class="pa-0" style="display: flex; align-items: center; justify-content: center" dense>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Lote Inicial" v-model="filtro.loteIdInicio" dense outlined hide-details clearable/>
                  </v-col>
                  <v-col cols="1" md="1">
                    <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                  </v-col>
                  <v-col cols="5" sm="4" md="5">
                    <v-text-field label="Lote Final" v-model="filtro.loteIdFim" dense outlined hide-details clearable/>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete style="margin-top: 4px" v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                  item-text="cpfCnpjNome" item-value="id" label="Doador" dense outlined hide-details/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete style="margin-top: 4px" v-model="filtro.situacao" :items="situacoes" item-value="id" item-text="nome" label="Situação" dense outlined clearable hide-details/>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-spacer/>
              <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">        
        <template v-slot:[`item.actions`]="{ item }">

          <v-tooltip right v-if="item.situacao == 1">
            <template v-slot:activator="{ on }">
              <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip right v-if="item.situacao == 1">
            <template v-slot:activator="{ on }">
              <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>

          <v-tooltip right  v-if="(item.situacao == 1 || item.situacao == 4) && !item.loteId">
            <template v-slot:activator="{ on }">
              <v-icon small @click="Enviar(item)" v-on="on">mdi-send</v-icon>
            </template>
            <span>Enviar</span>
          </v-tooltip>

          <v-tooltip right v-if="(item.situacao == 4 || item.situacao == 5) && !item.loteId">
            <template v-slot:activator="{ on }">
              <v-icon small @click="AtualizarRps(item)" v-on="on">mdi-cloud-refresh-variant</v-icon>
            </template>
            <span>Atualizar RPS</span>
          </v-tooltip>

          <v-tooltip right v-if="item.situacao == 2">
            <template v-slot:activator="{ on }">
              <v-icon small @click="Imprimir(item)" v-on="on">mdi-printer</v-icon>
            </template>
            <span>Imprimir</span>
          </v-tooltip>

        </template>

        <template v-slot:[`item.dataEmissao`]="{ item }">
          {{new Date(item.dataEmissao).ddmmyyyy()}}
        </template>

        <template v-slot:[`item.valor`]="{ item }">
          {{item.valor.toMoeda()}}
        </template>

        <template v-slot:[`item.valorRetido`]="{ item }">
          {{item.valorRetido.toMoeda()}}
        </template>

        <template v-slot:[`item.valorLiquido`]="{ item }">
          {{item.valorLiquido.toMoeda()}}
        </template>

        <template v-slot:[`item.enviado`]="{ item }">
          {{item.enviado.toSimNao()}}
        </template>

      </v-data-table>

      <cadastro-nfse v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()"/>
      <gerar-nfse v-model="dialogGerar" :item="itemGerar" @fechou="dialogGerar = false" @salvou="Atualizar()"/>

      <v-overlay :value="primeiraCarga">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </template>

  </list-page>
</template>

<script>
import NFSeService from '@/core/services/fiscal/NFSeService';
import NFSe from '@/core/domain/fiscal/NFSe';
import ListPage from "@/components/shared/ListPage";
import DoadorService from '@/core/services/doacao/DoadorService';

export default {
   extends: ListPage,
   data: () => ({
     headers: [
       { text: '', value:'actions', sortable: false  },
       { text: 'RPS', value: 'numeroRps', type: 'number' },
       { text: 'Número', value: 'numero', type: 'number' },
       { text: 'Chave Acesso', value: 'chaveAcesso', type: 'number' },
       { text: 'Emissão', value: 'dataEmissao', type: 'date' },
       { text: 'Doador', value: 'doador.nome' },
       { text: 'Discriminação', value: 'discriminacao' },
       { text: 'Valor', value: 'valor', type: 'number', align: 'right' },
       { text: 'Valor Retido', value: 'valorRetido', type: 'number', align: 'right' },
       { text: 'Valor Líquido', value: 'valorLiquido', type: 'number', align: 'right' },
       { text: 'Recebível', value: 'recebivelId' },
       { text: 'Lote', value: 'loteId' },
       { text: 'Situação', value: 'situacaoStr' },
       { text: 'E-mail Enviado', value: 'enviado' }
     ],
     itemGerar: {},
     primeiraCarga: true,
     dialogGerar: false,
     filtro: {
      numeroRpsInicio: null,
      numeroRpsFim: null,
      numeroInicio: null,
      numeroFim: null,
      dataEmissaoInicio: new Date().yyyymmdd(),
      dataEmissaoFim: new Date().yyyymmdd(),
      doadorId: null,
      valorInicio: null,
      valorFim: null,
      recebivelInicio: null,
      recebivelFim: null,
      loteIdInicio: null,
      loteIdFim: null,
      situacao: null
     },

     doadores: [],
     searchDoador: null,
     isDoadorLoading: false,
     
     situacoes: [
      { id: null, nome: "TODOS"},
      { id: 1, nome: "Em digitação"},
      { id: 2, nome: "Autorizada"},
      { id: 3, nome: "Cancelada"},
      { id: 4, nome: "Rejeitada"},
      { id: 5, nome: "Enviado"},
     ]
   }),
   created() {
     this.service = new NFSeService();
   },
   watch:{
    options: {
      handler () {
        // this.Atualizar();
      }
    },
    lista: function(){
      if(this.primeiraCarga)
        this.primeiraCarga = false;
    },
    searchDoador (val) {
      if (this.isDoadorLoading) return;
      if (!val) return;      
      if (this.filtro.doadorId) return;
      
      this.isDoadorLoading = true
      let doadorService = new DoadorService();
      doadorService.AutoComplete(val).then(
        res => {
          this.doadores = res.data;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      ).finally(() => {
          this.isDoadorLoading = false
        })
      },
    },
   methods: {
     Novo(){
       this.NovoCadastro(new NFSe());
     },
     Editar(item){
       this.service.ObterPorId(item.id)
         .then(
           res =>{
             this.EditarCadastro(new NFSe(res.data));
           },
           err => this.$swal('Aviso', err.response.data, 'error')
         )
     },
     GerarNFSe(){
        this.dialogGerar = true;
     },
     Atualizar(){
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro, "Doador").then(
          res => {
            this.lista = res.data.items;
            this.totalLista = res.data.count;
            this.loading = false;
          },
          err => {
            this.loading = false;
            this.$swal('Aviso', err.response.data, 'error')
          }
        );
    },
    Enviar(item){
      this.primeiraCarga = true;
      this.service.Transmitir(item.id).then(
        res =>{
          this.$swal('Aviso', res.data, 'success');
          this.Atualizar();
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      ).finally(() => this.primeiraCarga = false);
    },
    EnviarLote(){
      this.primeiraCarga = true;
      this.service.TransmitirLote().then(
          res =>{
            this.$swal('Aviso', res.data, 'success');
            this.Atualizar();
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        .finally(() => this.primeiraCarga = false);
    },
    AtualizarRps(item){
      this.primeiraCarga = true;

      this.service.AtualizarRps(item.id)
        .then(
          res =>{
            this.$swal('Aviso', res.data, 'success');
            this.Atualizar();
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        .finally(() => this.primeiraCarga = false);
    },
    AtualizarLote(){
      this.primeiraCarga = true;

      this.service.AtualizarLote()
        .then(
          res =>{
            this.$swal('Aviso', res.data, 'success');
            this.Atualizar();
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        .finally(() => this.primeiraCarga = false);
    },
    Imprimir(item){
      let url = item.urlVisualizacao;

      if (!url && item.nfseAutorizacao && item.nfseAutorizacao.urlVisualizacao){
        url = item.nfseAutorizacao.urlVisualizacao;
      }

      if (!url && item.autorizacao && item.autorizacao.urlVisualizacao){
        url = item.autorizacao.urlVisualizacao;
      }

      if (!url){
        this.$swal('Aviso', 'URL de visualizacao nao disponivel.', 'warning');
        return;
      }

      window.open(url, "_blank");

    },
   },
   mounted() {

   }
}
</script>
<style scoped>

</style>
